// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"96abeba9","455":"e6f9cc53","674":"ebc4cf48","723":"2fcb128d","787":"210af594","986":"e110aec9"}[chunkId] + ".chunk.js";
};